import { render, staticRenderFns } from "./Senate.vue?vue&type=template&id=78ef7a0a&"
import script from "./Senate.vue?vue&type=script&lang=js&"
export * from "./Senate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports